/**
 * @(#)2019/9/6.
 * 图片组件，展示一组或者一个图片
 * @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import "./index.less";
import Basics from "../Basics";
import { isEqual, isArray, isObject, omit } from "lodash";
import React, { Component } from "react";
import { Connection, YxComponent } from "../../YxComponent";
import Upload from "../../YxInput/YxUpload";
import { toArray, get, merge, yxTextImgProps } from "../../../utils";

/**
 * @param {arrry} list
 *
 * @class Img
 * @extends {YxComponent}
 */
class Img extends YxComponent {
  constructor(props, context) {
    super(props, context);
  }

  source(props_) {
    const props = props_ || this.props;
    return get(props, ["children", "data", "list"], []);
  }

  shouldComponentUpdate(nextProps) {
    const oldImgs = this.source();
    const imgs = this.source(nextProps);
    return !isEqual(oldImgs, imgs);
  }

  get list() {
    const source = this.source();
    let result = [];
    if (source instanceof Array) {
      for (let item of source) {
        if (typeof item === "string") {
          result.push(item);
        } else {
          result.push(get(item, ["children", "data", "value", "src"], ""));
        }
      }
    } else if (typeof source === "string") {
      result = toArray(source);
    }
    return result;
  }

  productionHtml() {
    const props = { ...this.props };
    const imgParam = get(props, "controlParam", {});

    let classParam = {
      yx_yxText_img_: "styleParam.type",
      yx_yxText_img_size_: "styleParam.size",
    };
    const param = {
      list: this.list,
      isControlled: true,
      formItemParam: {
        className:
          "yx_imgs_formItem " +
          this.styleParamClassName(props, classParam) +
          (get(props, "onlySee", false) ? " only_see" : ""),
        wrapperCol: {},
      },
    };
    props.children = (
      <Upload {...merge(param, imgParam)} isRead={true}></Upload>
    );
    return Basics.html(yxTextImgProps(props));
  }

  render() {
    return <div className="yx_yxText_imgs">{this.productionHtml()}</div>;
  }
}

export default Img;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Img/Img.js